import * as angular from 'angular';
import { ComponentDefinition } from '../../../models';

class ConfirmDeleteModalController implements angular.IComponentController {
    deleteFunction: any;
    item: any;
    static $inject = [];

    onDelete(item: any) {
        if (this.deleteFunction) {
            this.deleteFunction({ item: this.item });
        }
    }
}

export const wtConfirmDeleteModal: ComponentDefinition = {
    componentId: 'wtConfirmDeleteModal',
    controller: ConfirmDeleteModalController,
    controllerAs: 'vm',
    template: require('./confirmDeleteModal.component.html'),
    bindings: {
        deleteFunction: '&',
        id: '@',
        item: '<',
        label: '@',
        'translateParams': '<?'
    }
};